import React, { useState, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import SelectTab from '../share/SelectTab';
import type { ReservationType } from '../share/reservation_type';
import { bookingTypeParamKeyOf, subTabOf } from '../share/reservation_type';
import Total from './total/total';
import Items from './items/items';

const AnaTab = {
  TOTAL: '総数',
  ITEMS: '全件'
} as const;
export type AnaTabType = keyof typeof AnaTab;

interface Props {
  reservationType?: ReservationType;
}

const AnaBooking: React.FC<Props> = observer(({ reservationType = 'ana' }) => {
  const history = useHistory();
  const subTab = subTabOf(reservationType);
  const bookingTypeParamKey = bookingTypeParamKeyOf(reservationType);
  const [anaBookingTab, setAnaBookingTab] = useState<AnaTabType>(
    (utils.getParam(bookingTypeParamKey) as AnaTabType) ||
      (utils.getParam('ana_booking_tab') as AnaTabType) ||
      'TOTAL'
  );

  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
    currentParams.set('sub_tab', subTab);
    if (!currentParams.has(bookingTypeParamKey)) {
      currentParams.set(bookingTypeParamKey, anaBookingTab);
    }
    history.replace(`/arrangement/todo_list?${currentParams.toString()}`);
  }, [history, anaBookingTab, subTab, bookingTypeParamKey]);

  const handleTabChange = useCallback(
    (tab: AnaTabType) => {
      setAnaBookingTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', subTab);
      currentParams.set(bookingTypeParamKey, tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history, subTab, bookingTypeParamKey]
  );

  return (
    <>
      <SelectTab tabs={AnaTab} currentTab={anaBookingTab} onChange={handleTabChange} />
      {anaBookingTab === 'TOTAL' ? (
        <Total reservationType={reservationType} />
      ) : (
        <Items reservationType={reservationType} />
      )}
    </>
  );
});

export default AnaBooking;
